import React from 'react';
import { Link } from 'react-router-dom';
import Bluedots from '../../assets/images/blue_dotes.png'
import howstep1 from '../../assets/images/howstep1.png'
import howstep2 from '../../assets/images/howstep2.png'
import howstep3 from '../../assets/images/howstep3.png'

function HowWork() {
  return (

    <section className="how_it_section white_text">
      <div className="how_it_inner" data-aos="fade-in" data-aos-duration={1500}>
        <div className="dotes_blue">
          <img src={Bluedots} alt="image" />
        </div>
        <div className="container">
          <div className="section_title" data-aos="fade-up" data-aos-duration={1500}>
            <span className="title_badge">Atât de simplu</span>
            <h2>Totul începe cu <span>3 pași</span></h2>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="steps_block step_border" data-aos="fade-up" data-aos-duration={1500} >
                <div className="steps">
                  <div className="icon">
                    <img src={howstep1} alt="image" />
                  </div>
                  <div className="text">
                    <h3>Descarcă aplicația</h3>
                    <ul className="social">
                      <li>
                        <Link to="#">
                          <i className="icofont-brand-android-robot" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="icofont-brand-apple" />
                        </Link>
                      </li>
                      {/*<li>
                        <Link to="#">
                          <i className="icofont-brand-windows" />
                        </Link>
                      </li>*/}
                    </ul>
                    <p>
                      Disponibilă pentru Android,<br/> iOS sau în browser
                    </p>
                  </div>
                </div>
                <span className="step">01</span>
              </div>
            </div>
            <div className="col-md-4">
              <div className="steps_block step_border" data-aos="fade-up" data-aos-duration={1500}>
                <div className="steps">
                  <div className="icon">
                    <img src={howstep2} alt="image" />
                  </div>
                  <div className="text">
                    <h3>Crează-ți contul</h3>
                    <span className="tag_text">Mereu <span style={{fontWeight: 800}}>&nbsp;GRATIS</span></span>
                    <p>
                    Completezi câteva detalii și<br />ești gata de rezervare
                    </p>
                  </div>
                </div>
                <span className="step">02</span>
              </div>
            </div>
            <div className="col-md-4">
              <div className="steps_block" data-aos="fade-up" data-aos-duration={1500} >
                <div className="steps">
                  <div className="icon">
                    <img src={howstep3} alt="image" />
                  </div>
                  <div className="text">
                    <h3>Rezervă și câștigă</h3>
                    <span className="tag_text">Mereu ceva în <span style={{fontWeight: 800}}>&nbsp;PLUS</span></span>
                    <p>
                    Rezervă online. Acumulează puncte.<br />Câștigă premii
                    </p>
                  </div>
                </div>
                <span className="step">03</span>
              </div>
            </div>
          </div>
          <div className="text-center">
            <div className="btn_block">
              <Link to="/contact" className="btn puprple_btn color-lumo-orange ml-0">
                Ai întrebări? Avem răspunsuri!
              </Link>
              <div className="btn_bottom border-color-lumo-orange" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
export default HowWork;
